import { format as dateFormat } from "date-fns";
import React from "react";

import UserUpdate from "./UserUpdate";

import { useEnvironment } from "@SonarCX/providers/EnvironmentProvider";
import { useUserAPI } from "@SonarCX/providers/UserAPIProvider";
import { formatDateRelative } from "@SonarCX/utilities";
import useStyles from "./styles";

type UserActivityProps = {
  activity: UserActivityResponse;
};

const UserActivity: React.FC<UserActivityProps> = ({ activity }) => {
  const { allUsers, loadUser } = useUserAPI();
  const { user: currentUser } = useEnvironment();

  const classes = useStyles();

  const user = React.useMemo(
    () => allUsers[activity.user_id] ?? null,
    [allUsers, activity.user_id],
  );

  const userName = React.useMemo(
    () => (user?.id === currentUser?.id ? "You" : user?.name),
    [user, currentUser],
  );

  const time = React.useMemo(
    () =>
      `${dateFormat(
        new Date(activity.stamp),
        "h:mm aaa",
      )}, ${formatDateRelative(activity.stamp, true)}`,
    [activity.stamp],
  );

  // Load concerning user if needed
  React.useEffect(() => {
    if (!user) {
      loadUser(activity.user_id);
    }
  }, [user, loadUser, activity.user_id]);

  if (activity.action === "updated") {
    return (
      <>
        {Object.entries(activity.content).map(([type, { previous, value }]) => (
          <label key={type} className={classes.root}>
            <div className={classes.activity}>
              <UserUpdate
                type={type}
                oldValue={previous}
                newValue={value}
                name={userName}
              />
            </div>
            <div className={classes.time}>{time}</div>
          </label>
        ))}
      </>
    );
  }

  return (
    <label className={classes.root}>
      <div className={classes.activity}>
        User <span className="emphasize">{activity.action}</span> by {userName}
      </div>
      <div className={classes.time}>{time}</div>
    </label>
  );
};

export default UserActivity;
